import { MetaRoot } from 'util/metaPath'

import AtestadoModel from './components/model-atestado'

export const createCpfCnsCalculation = (path: MetaRoot<AtestadoModel>) => ({
  field: path.naoPossui.absolutePath(),
  updates: {
    [path.cpfCns.absolutePath()]: (naoPossui: boolean | undefined, allValues: AtestadoModel) =>
      naoPossui ? undefined : allValues.cpfCns,
  },
})

export const createDescricaoCalculation = (
  path: MetaRoot<AtestadoModel>,
  fields: string[],
  getDescricao: (values: AtestadoModel) => string
) => ({
  field: fields,
  updates: {
    [path.descricao.absolutePath()]: (_: unknown, allValues: AtestadoModel) => getDescricao(allValues),
  },
})
